<template>

  <div>

    <vx-card>
      <!-- SEARCH BAR -->
      <div class="grid gap-4 items-end lg:grid-cols-7 md:grid-cols-1">
        <div class="lg:col-span-3">
          <label>Data do portfolio</label>
          <date-picker
            name="data do portfolio"
            type="month"
            value-type="YYYY-MM-DD"
            v-model="portfolioDate"
            class="w-full"/>
        </div>

        <div>
          <vs-button
            class="w-full"
            @click="clearFilter()"
            icon-pack="fa"
            icon="fa-eraser"
            title="Limpar"><span class="auto-hide-clear-text">Limpar</span></vs-button>
        </div>

        <div>
          <vs-button class="w-full" @click="refine(portfolioDate)" icon="search">Buscar</vs-button>
        </div>

        <div>
          <vs-button
            class="w-full"
            @click="downloadTemplate()"
            icon-pack="fa"
            title="Limpar"><span class="auto-hide-clear-text">Download Template</span></vs-button>
        </div>

        <div>
          <vs-button
            class="w-full"
            @click="activePrompt = true"
            icon-pack="fa"
            title="Limpar"><span class="auto-hide-clear-text">Upload Portfolio</span></vs-button>
        </div>
      </div>

    </vx-card>

    <vx-card class="mt-4">
      <vs-table stripe :data="portfolios" class="w-full mt-4" noDataText="Nenhum registro encontrado.">
        <template slot="header">
          <p class="font-bold">Portfolios</p>
        </template>
        <template slot="thead">
          <th>Data</th>
          <th>Criado Em</th>
          <th>Criado Por</th>
          <th>Status</th>
          <th>Ação</th>
          <th>Exportar</th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(row, indextr) in data">
            <td>
              <a role="button" style="cursor: pointer" @click="viewLog(row.guid)">{{row.portfolioDate | formatDate}}</a>
            </td>
            <td>
              {{row.createdAt | formatDate}}
            </td>
            <td>
              {{row.createdByStr}}
            </td>
            <td>
              {{row.status | formatPortfolioStatus}}
            </td>
            <td>
              <a role="button" style="cursor: pointer" @click="deletePortfolio(row.guid)">apagar</a>
            </td>
            <td>
              <a role="button" style="cursor: pointer" @click="downloadPortfolio(row.guid)">Download</a>
            </td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="my-5">
        <vs-pagination
          v-model="page"
          :total="totalPages">
        </vs-pagination>
      </div>

    </vx-card>

    <vs-prompt
      @accept="addPortfolio"
      @close="close"
      title="Novo Portfolio"
      accept-text="Adicionar"
      :active.sync="activePrompt">
      <div class="grid grid-rows-2 gap-2">

          <div class="mt-4">
            <label class="file-select">
              <div class="select-button">
                <span v-if="file">Arquivo selecionado: {{file.name}}</span>
                <span v-if="file === ''" class="vs-component vs-button vs-button-primary vs-button-filled">Selecione um arquivo</span>
              </div>
              <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
            </label>
          </div>

      </div>
    </vs-prompt>

    <vs-prompt
      @close="close"
      title="Log de Upload"
      :buttons-hidden="true"
      :active.sync="activeLogPrompt">
      <vs-table stripe :data="portfolioLogs" noDataText="Nenhum registro encontrado.">

        <template slot="thead">
          <th>Descrição</th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(row, indextr) in data">
            <td>
              {{row.description}}
            </td>
          </vs-tr>
        </template>

      </vs-table>
    </vs-prompt>


  </div>
</template>

<script>
import axios from "axios"
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import UserAuthorization from '@/mixins/UserAuthorization';

export default {
  name: "PortfolioList",
  mixins:[UserAuthorization],
  components: {
    DatePicker
  },
  data () {
    return {
      activePrompt: false,
      activeLogPrompt: false,
      portfolioDate: null,
      portfolioUploadDate: null,
      portfolios: [],
      portfolioLogs: [],
      file: '',
      totalPages: 0
    }
  },
  beforeMount() {
    this.loadPortfolios()
  },
  methods: {

    close () {
      this.activePrompt = false
    },

    closeLog () {
      this.activeLogPrompt = false
    },

    openPrompt () {
      this.activePrompt = true
    },

    addPortfolio () {
      const formData = new FormData()
      formData.append('file', this.file)
      axios.post(`${process.env.VUE_APP_API}/api/v1/portfolio`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        this.valueResponse = response.data
      })
      .finally(()=>{
        this.file = ''
        this.portfolioUploadDate = ''
        this.loadPortfolios()
      })

    },

    clearFilter () {
      this.portfolioDate = null
      this.loadPortfolios()
    },

    refine() {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/portfolio/date`, {
        params: {
          date: this.portfolioDate
        }
      })
        .then((response) => {
          this.portfolios = response.data.content
          this.totalPages = response.data.totalPages
        })
    },

    loadPortfolios() {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/portfolio`)
        .then((response) => {
          this.portfolios = response.data.content
          this.totalPages = response.data.totalPages
      })
    },

    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },

    view (guid) {
      this.$router.push({path: `/portfolio/${guid}`})
    },

    viewLog (guid) {
      this.activeLogPrompt = true
      axios.get(`${process.env.VUE_APP_API}/api/v1/portfolio/${guid}/log`)
        .then((response) => {
          this.portfolioLogs = response.data
        })
    },

    deletePortfolio (guid) {
      axios.delete(`${process.env.VUE_APP_API  }/api/v1/portfolio/${guid}`)
        .finally(() => {
          this.loadPortfolios()
      })
    },

    downloadTemplate() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/portfolio/template/`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },

    downloadPortfolio(guid) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/portfolio/download/${guid}`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },

  }
}
</script>

<style scoped>
/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
</style>
